import QuizContentWrapper from './QuizContentWrapper';

export default QuizContentWrapper;
